var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
export function getCurrentUser() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/users/{user_id}", {
            params: { path: { user_id: "current" } },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function addFavoriteToolQuery(userId, toolId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().PUT("/api/users/{user_id}/favorites/{object_type}", {
            params: { path: { user_id: userId, object_type: "tools" } },
            body: { object_id: toolId },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data.tools;
    });
}
export function removeFavoriteToolQuery(userId, toolId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().DELETE("/api/users/{user_id}/favorites/{object_type}/{object_id}", {
            params: {
                path: {
                    user_id: userId,
                    object_type: "tools",
                    object_id: toolId,
                },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data.tools;
    });
}
export function setCurrentThemeQuery(userId, theme) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().PUT("/api/users/{user_id}/theme/{theme}", {
            params: { path: { user_id: userId, theme } },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
